export enum FilterView {
  BY_PARAMS = 'byParams',
  BY_STOCK = 'byStock',
}
